import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialTiktokSoloIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M17.4022 7.35113C16.5015 6.76402 15.8519 5.82423 15.6489 4.72927C15.6053 4.49275 15.581 4.2491 15.581 4H12.7066L12.702 15.5191C12.6538 16.809 11.592 17.8444 10.2907 17.8444C9.886 17.8444 9.50522 17.7434 9.16973 17.5668C8.40062 17.1621 7.87432 16.3561 7.87432 15.4285C7.87432 14.0962 8.95837 13.0121 10.2903 13.0121C10.5389 13.0121 10.7776 13.0532 11.0032 13.1237V10.1894C10.7696 10.1575 10.5322 10.1378 10.2903 10.1378C7.37318 10.1378 5 12.511 5 15.4285C5 17.2183 5.89408 18.8023 7.25869 19.7601C8.11797 20.3636 9.16344 20.7188 10.2907 20.7188C13.2078 20.7188 15.581 18.3456 15.581 15.4285V9.58718C16.7082 10.3961 18.0896 10.8729 19.58 10.8729V7.99863C18.7773 7.99863 18.0296 7.76001 17.4022 7.35113Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
